module.exports = __webpack_public_path__ + "static/media/logo.8af6e0a3.png";